// extracted by mini-css-extract-plugin
export default {"my-masonry-grid":"MasonryLayout_my-masonry-grid__1z-HF","my-masonry-grid_column":"MasonryLayout_my-masonry-grid_column__Jbh5s"};